const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-CustomPaneHtml-View'];

class HeadlightPaneCustom extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);
	}
}

module.exports = HeadlightPaneCustom;

module.exports.default_configuration = _ViewConfiguration;
